module.exports = __webpack_public_path__ + "img/hr_get.8d84e01.png";